import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useMemo } from "react";
import {
	Datagrid,
	EditButton,
	DeleteButton,
	CheckboxGroupInput,
	Filter,
	SimpleForm,
	List,
	SearchInput,
	SelectInput,
	ShowButton,
	TextField,
	TextInput,
	BooleanInput,
	BooleanField,
	useGetList,
	usePermissions,
	useTranslate,
	downloadCSV,
	FunctionField,
} from "react-admin";
import { ExportButton } from "ra-ui-materialui";
import jsonExport from "jsonexport/dist";
import { CustomDeleteButtonWithConfirmation } from "../../customComponents/CustomButtons";
import { CustomEmptyDialog } from "../../customComponents/CustomEmptyDialog";
import { checkIfExists, checkPermission } from "../../utils/customFunctions";
import { userPreferences } from "../../utils/fakeUserPrefrences";
import {
	getChoices,
	requiredPermissions,
	requiredStatuses,
	statusEnumsObject,
} from "./shared";
import { envSettings } from "../../settings/env";
import VideocamIcon from "@mui/icons-material/Videocam";
import VideocamOffIcon from "@mui/icons-material/VideocamOff";

const TitleField = ({ record }) => {
	if (!record?.title) return "";
	return record.title;
};

const DescriptionField = ({ record }) => {
	if (!record?.description) return "";
	const description = record.description || "";
	return description.length > 50
		? `${description.substring(0, 50)}...`
		: description;
};

const VideoAttachedField = ({ record }) => {
	console.log("VideoAttachedField record:", record);
	return record?.videoAssetId ? (
		<VideocamIcon color="primary" />
	) : (
		<VideocamOffIcon color="disabled" />
	);
};

const DebugField = ({ record, source }) => {
	console.log("DebugField record:", record);
	console.log("DebugField source:", source);
	console.log("DebugField value:", record?.[source]);
	return <span>{String(record?.[source])}</span>;
};

const HandoutFilter = ({ ...props }) => {
	const translate = useTranslate();

	return (
		<Filter {...props}>
			<SearchInput source="search" alwaysOn />
			<BooleanInput source="isActive" label="Active" />
		</Filter>
	);
};

export const HandoutList = (props) => {
	const { loadingPermissions, permissions } = usePermissions();
	const hasRequiredStatus = useRef(false);
	const hasPermission = useRef(false);
	const [open, setOpen] = useState(false);
	const defaultLocale = useMemo(
		() => userPreferences.defaultTranslationLanguage,
		[]
	);

	useEffect(() => {
		hasPermission.current = checkIfExists(
			props.permissions,
			requiredPermissions
		);
	}, [props.permissions]);

	useEffect(() => {
		hasRequiredStatus.current = checkIfExists(
			props.status,
			requiredStatuses
		);
	}, [props.status]);

	const Delete = (props) => {
		const {
			record: { isDeletable, isLinked },
		} = props;
		const translate = useTranslate();
		if (!isDeletable) return <></>;
		if (isLinked)
			return (
				<CustomDeleteButtonWithConfirmation
					confirmTitle={translate("handouts.delete.confirmTitle")}
					confirmContent={translate("handouts.delete.confirmContent")}
					{...props}
				/>
			);
		return <DeleteButton {...props} />;
	};

	const handleCancel = () => {
		setOpen(false);
	};

	return (
		<List
			bulkActionButtons={false}
			exporter={false}
			{...props}
			filters={<HandoutFilter />}
			sort={{ field: "rank", order: "ASC" }}
		>
			<>
				<Datagrid>
					<TextField
						source="title"
						label="Title"
						sortable={false}
					/>
					<TextField
						source="description"
						label="Description"
						sortable={false}
					/>
					<TextField
						source="rank"
						label="Rank"
						sortable={false}
					/>
					<FunctionField
						label="Active Status"
						render={(record) =>
							record?.isActive ? "Active" : "Inactive"
						}
						sortable={false}
					/>
					<FunctionField
						label="Video Attached"
						render={(record) =>
							record?.videoAssetId ? "Yes" : "No"
						}
						sortable={false}
					/>
					<ShowButton />
					<EditButton />
					<Delete />
				</Datagrid>
			</>
		</List>
	);
};
